<div class="chat-message" [class.user]="isUser" [class.bot]="isBot" #chatMessage>
  <div
    class="message"
    [class.user]="isUser"
    [class.bot]="isBot && message()?.type !== MessageFunctionType.Loading"
    [class.loading]="message()?.type == MessageFunctionType.Loading"
    >
    @if (isBot && message()?.type == MessageFunctionType.Table) {
      <div class="message-actions">
        @if (isBot && message()?.type == MessageFunctionType.Table) {
          <div
            class="download-button"
            [class.disabled]="isCopyIconDisabled"
            (click)="download(message())"
            >
            <mat-icon svgIcon="download-icon-new"></mat-icon>
          </div>
        }
      </div>
    }
    <div class="message-content">
      @if (message()?.type === MessageFunctionType.Loading) {
        <div class="typing-animation">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      } @else {
        <miq-dynamic-chat-loader [message]="message()"></miq-dynamic-chat-loader>
        @if (isBot && message()?.type !== MessageFunctionType.Loading) {
          <div class="feedback">
            @if (index() === 1) {
              <p class="feedback-text">
                {{ 'chat.feedbackText' | translate }}
              </p>
            }
            <div class="feedback-actions">
              <mat-icon
                class="feedback-icon"
                [ngClass]="{ selected: message().feedback === true }"
                [svgIcon]="message().feedback === true ? 'thumb_up_filled' : 'thumb_up'"
                (click)="giveFeedback(true)"
                >
              </mat-icon>
              <mat-icon
                class="feedback-icon"
                [ngClass]="{ selected: message().feedback === false }"
                [svgIcon]="message().feedback === false ? 'thumb_down_filled' : 'thumb_down'"
                (click)="giveFeedback(false)"
                >
              </mat-icon>
            </div>
          </div>
        }
      }
    </div>
  </div>
  @if (message()?.senderInitial) {
    <div class="initials" [class.user]="isUser" [class.bot]="isBot">
      @if (isUser) {
        {{ message()?.senderInitial }}
      } @else {
        <mat-icon class="ellis-avatar-icon" svgIcon="ellis-ai-avatar"></mat-icon>
      }
    </div>
  }
</div>
